/**
 * 实现全局的请求 loading
 *  <pre>
 * 作者:wei yang
 * 邮箱:1205181727@qq.com
 * 日期:2015-11-02-下午3:29:34
 * 版权:广州百拓开源信息科技有限公司
 * </pre>
 */
import { Loading } from 'element-ui'
import { debounce } from 'lodash'
import I18n from '@/utils/i18n' // Internationalization 国际化
import NProgress from 'nprogress' // progress bar

let needLoadingRequestCount = 0
let loading
let nprogressNeedLoadingCount = 0

// 配置NProgress
NProgress.configure({ showSpinner: false, minimum: 0.2, easeing: 'swing', speed: 1000, trickleRate: 0.2 })

/**
 * 加载
 * @param {*} config
 */
function startLoading(config = {}) {
  loading = Loading.service({
    lock: config.lock || true,
    text: config.text || I18n.t('common.loading'),
    background: config.background
  })
}

/**
 * 清除loaing
 */
function closeLoading() {
  loading.close()
}

const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    closeLoading()
  }
}

export function showFullScreenLoading(config) {
  if (needLoadingRequestCount === 0) {
    startLoading(config)
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    debounce(tryCloseLoading, 100)()
  }
}

// nprogress 开始loading
export const NProgressStartLoading = () => {
  if (nprogressNeedLoadingCount === 0) {
    NProgress.start()
  }
  nprogressNeedLoadingCount++
}

// nprogress 结束loading
export const NProgressEndLoading = () => {
  nprogressNeedLoadingCount--
  if (nprogressNeedLoadingCount <= 0) {
    NProgress.done()
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js